// extracted by mini-css-extract-plugin
export default {"OptionsMenuAnchor":"StreamOptions_OptionsMenuAnchor__fZgrg","MeatballsIcon":"StreamOptions_MeatballsIcon__4ZJ+8"};